import { render, staticRenderFns } from "./WorkshopGroupDetail.vue?vue&type=template&id=1e3a0689&scoped=true&"
import script from "./WorkshopGroupDetail.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroupDetail.vue?vue&type=style&index=0&id=1e3a0689&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a0689",
  null
  
)

export default component.exports